import { useState } from "react";
import { Header, Button } from "semantic-ui-react";
import { FrameVanishDiv, VanishDiv } from "./SmallComponents";
import ZoneOrb from "./ZoneOrb.js";


function AreaMenu(props) {

    const [menuArea, setMenuArea] = useState("Main");

    return  <FrameVanishDiv key="menu" >
                
                <div style={{ height: "100vh", width: "45vw", position: "fixed", left: "5vw", top: "10vh" }}>
                <ZoneOrb
                    startGame={true}
                    feeling={"sad"}
                    moodValue={0}
                    fillColor={"#003399"}
                    size={500}
                />
                </div>

                {menuArea == "Main" && (
                <VanishDiv style={{ height: "100vh", width: "30vw", position: "fixed", right: "15vw", top: "0" }}>
                    <Header as='h1' style={{ fontSize: "80px", color: "white", padding: "10% 0" }}> My Friend<br/> Is Sad </Header>
                    <MenuButton onClick={() => props.setArea("game")} >Talk to Them</MenuButton>
                    <MenuButton onClick={() => setMenuArea("Instructions")}>Instructions</MenuButton>
                    <MenuButton onClick={() => setMenuArea("Credits")}>Credits</MenuButton>
                </VanishDiv>)}

                
                {menuArea == "Instructions" && (
                <VanishDiv style={{ height: "100vh", width: "30vw", position: "fixed", right: "15vw", top: "0", fontSize: "20px", padding: "10% 0" }}>
                    <p>Your friend is sad.</p>
                    <p>Your goal is to improve their mood as much as possible before the conversation ends.</p>
                    <p>It's okay if you're not perfect. Do your best.</p>
                    <p>You'll get better as you get more Empathy.</p>
                    <MenuButton onClick={() => setMenuArea("Main")}>Back</MenuButton>
                </VanishDiv>)}

                {menuArea == "Credits" && (
                <VanishDiv style={{ height: "100vh", width: "30vw", position: "fixed", right: "15vw", top: "0", fontSize: "20px", padding: "10% 0" }}>
                    <p>This game was made by <a target="_blank" href="http://abigailcorfman.com/">Abigail Corfman.</a></p>
                    <p>Animation based on <a target="_blank" href="https://codepen.io/hakimel/pen/DKKxeo">Trail</a> by Hakim El Hattab</p>
                    <p>Gameplay concept based on crafting in Final Fantasy 14.</p>
                    <p>Made for the <a target="_blank" href="https://itch.io/jam/make-games-not-war">Make Games Not War</a> game jam.</p>
                    <MenuButton onClick={() => setMenuArea("Main")}>Back</MenuButton>
                </VanishDiv>)}


            </FrameVanishDiv>;
}


function MenuButton(props) {
    return <div style={{ margin: "5% 0", width: "70%" }} ><Button style={{ width: "100%" }} {...props} /></div>;
}


export default AreaMenu;